export interface UpdatePatchResponse {
  id: string;
  updatedAt: string;
  success: boolean;
}
